import { Wrench, HandHeart, Home } from "lucide-react";

const PHILOSOPHY_IMG =
  "https://images.pexels.com/photos/8817851/pexels-photo-8817851.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";

const POINTS = [
  {
    icon: Home,
    title: "Mehr als nur Vermittlung",
    text: "Ich begleite nicht nur Käufer und Verkäufer, ich kümmere mich auch danach um Ihre Immobilie — und das alles aus einer Hand.",
  },
  {
    icon: Wrench,
    title: "Hände, die wissen, was zu tun ist",
    text: "Kleine Reparaturen, Pflege oder Instandhaltung? Ich schaue nicht nur zu, ich packe selbst mit an.",
  },
  {
    icon: HandHeart,
    title: "Persönlich, nicht anonym",
    text: "Sie sprechen direkt mit mir — keine Hotline, keine wechselnden Ansprechpartner.",
  },
];

export default function Philosophy() {
  return (
    <section
      id="philosophie"
      data-testid="philosophy-section"
      className="bg-white py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-[#8A151B]" />
              <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#8A151B]">
                Philosophie
              </span>
            </div>

            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.05] text-[#0A0A0A]">
              Anders als
              <br />
              die meisten
              <br />
              <span className="text-[#8A151B]">Makler.</span>
            </h2>

            <p className="mt-8 text-lg text-neutral-600 leading-relaxed max-w-md">
              Die meisten verkaufen Häuser und verschwinden. Ich bleibe — als
              Makler, Berater und manchmal mit Werkzeug in der Hand.
            </p>

            <div className="hidden lg:block mt-12 border-t border-neutral-200 pt-8">
              <p className="font-display text-7xl font-black text-[#0A0A0A] leading-none">
                01<span className="text-[#8A151B]">.</span>
              </p>
              <p className="mt-3 text-xs uppercase tracking-[0.25em] text-neutral-500 font-semibold">
                Ein Ansprechpartner. Alles dabei.
              </p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src={PHILOSOPHY_IMG}
                alt="Handwerk und Sorgfalt"
                className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-[#8A151B] text-white px-6 py-4">
                <p className="text-xs uppercase tracking-[0.2em] font-bold">
                  Werkstatt-Mentalität
                </p>
                <p className="font-display text-xl mt-1">
                  &bdquo;Wenn ich es selbst kann, mache ich es selbst.&ldquo;
                </p>
              </div>
            </div>

            <div className="mt-12 space-y-10">
              {POINTS.map((p, i) => (
                <div
                  key={p.title}
                  data-testid={`philosophy-point-${i}`}
                  className="flex gap-6 group"
                >
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 border border-neutral-300 flex items-center justify-center group-hover:border-[#8A151B] group-hover:bg-[#8A151B] transition-all duration-300">
                      <p.icon
                        size={22}
                        strokeWidth={1.5}
                        className="text-[#0A0A0A] group-hover:text-white transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#0A0A0A]">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-neutral-600 leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
